import React from "react";

function CustomToolTip(props) {
  const { displayText = "dummy display name", className, maxWidth } = props;
  return (
    <div className="custom-tooltip-container">
      <div className="custom-tooltip-style border-0">
        <div
          className="px-2"
          style={{ backgroundColor: "black", transform: "translate(0px, 7px)" }}
        >
          {displayText}
        </div>
        <div
          style={{
            paddingLeft: "50%",
            backgroundColor: "white",
            color: "black",
          }}
        >
          <i className="fas fa-sort-down fa-lg"></i>
        </div>
      </div>
      <div
        style={{
          maxWidth: maxWidth,
          width: "max-content",
          textOverflow: "ellipsis",
          overflow: "hidden",
        }}
        className={className}
      >
        {displayText}
      </div>
    </div>
  );
}

export default CustomToolTip;
